// services/WorkspaceMembership.js
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";
import {getUser} from "../../system/storage";

export default class WorkspaceMembership extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "workspace-membership";
    static pluralName = "workspace-memberships";
    static displayName = "WorkspaceMembership";

    constructor() {
        super(`${WorkspaceMembership.kind}`,`${WorkspaceMembership.singularName}`,`${WorkspaceMembership.pluralName}`, {workspaceScoped: false});}

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query);
    }

    async getById(id, query = {}) {
        return await this.find(id, { populate: "*", ...query });
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data, workspaceDocumentIdOverride) {
        return await this.update(id, data, undefined, workspaceDocumentIdOverride);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }
}
